// src/store/slices/studentsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchStudents = createAsyncThunk(
  "students/fetchStudents",
  async (filters, thunkAPI) => {
    try {
      const params = new URLSearchParams();
            const state = thunkAPI.getState(); // Access Redux state

      const token = state.auth.userArray.access_token; // Assuming token is stored in auth slice

console.log(state.auth.userArray.access_token,"state.auth.userArray.access_token");

      const response = await axios.get(
        `https://nanosoft.space/taarteb/public/api/admin/student-expenses`,
          {
  headers: {
      Authorization: `Bearer ${state.auth.userArray.access_token}`,
    },        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetcAllStudents = createAsyncThunk(
  "students/fetcAllStudents",
  async (filters, thunkAPI) => {
    try {
      const params = new URLSearchParams();
            const state = thunkAPI.getState(); // Access Redux state

      const token = state.auth.userArray.access_token; // Assuming token is stored in auth slice

console.log(state.auth.userArray.access_token,"state.auth.userArray.access_token");

      const response = await axios.get(
        `https://nanosoft.space/taarteb/public/api/students`,
          {
  headers: {
      Authorization: `Bearer ${state.auth.userArray.access_token}`,
    },        }
      );

      return response.data.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);

const studentsSlice = createSlice({
  name: "students",
  initialState: {
    allList: [],
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetcAllStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetcAllStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.allList = action.payload;
      })
      .addCase(fetcAllStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  },
});

export default studentsSlice.reducer;
